import { NgModule } from "@angular/core";
import { NgbTimepickerModule } from "@ng-bootstrap/ng-bootstrap";
import { NgSelectModule } from "@ng-select/ng-select";
import { TranslateModule } from "@ngx-translate/core";
import { CommonComponentsModule } from "components/common/common-components.module";
import { IonicPageModule } from "ionic-angular";
import { SignInPage } from "./sign-in";

@NgModule({
  declarations: [SignInPage],
  imports: [
    IonicPageModule.forChild(SignInPage),
    TranslateModule.forChild(),
    NgSelectModule,
    NgbTimepickerModule,
    CommonComponentsModule,
  ],
  exports: [SignInPage],
})
export class SignInCognitoModule {}



// WEBPACK FOOTER //
// ./src/components/cognito/sign-in-cognito/sign-in.module.ts